'use client'
import { useMemo } from 'react';
import { useOnrampContext } from '../../../context/OnrampContext/OnrampContext.js';

const useOnramp = () => {
    const { onrampEnabled, openOnramp } = useOnrampContext();
    return useMemo(() => ({
        /**
         * Whether onramp is enabled.
         */
        enabled: onrampEnabled,
        /**
         * Opens the onramp modal.
         */
        open: openOnramp,
    }), [onrampEnabled, openOnramp]);
};

export { useOnramp };
